import React from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled } from '@mui/material/styles';
import {
    PageProperties,
    WidgetMenu,
} from '@sunwisesoftware/racking-template-core';
import {
    Box,
    Divider,
    Drawer,
    IconButton,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    getTemplateLanguageLabel,
    getTemplateTypeLabel,
} from '../../templates/helpers';

const WrapperSideMenu = styled(Box)`
    transition: width 0.5s ease-in-out;
`;

const SettingsDrawer = ({
    customTemplate,
    isDarkMode,
    setShowSettingsDrawer,
    showSettingsDrawer,
}) => {
    const { t } = useTranslation();
    return (
        <WrapperSideMenu
            sx={{
                height: '100%',
                width: { xs: 0, md: showSettingsDrawer ? 380 : 0 },
            }}
        >
            <Drawer
                sx={{
                    width: 380,
                    '& .MuiDrawer-paper': {
                        background: isDarkMode ? '#1b1c1f' : '#f2f4f9',
                        boxSizing: 'border-box',
                        height: '100%',
                        mt: { xs: '148px', md: 0 },
                        overflowY: 'scroll',
                        p: 2,
                        width: { xs: 300, md: 380 },
                    },
                }}
                variant="persistent"
                anchor="right"
                open={showSettingsDrawer}
            >
                <Box alignItems="center" display="flex" gap={1} p={1}>
                    <IconButton onClick={() => setShowSettingsDrawer(false)}>
                        <ChevronRightIcon />
                    </IconButton>
                    <Typography fontWeight="bold" variant="title">
                        {t('Property', { count: 2 })}
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Box alignItems="center" display="flex" gap={1}>
                    <Typography fontWeight="bold" variant="body2">
                        {t('Language')}:
                    </Typography>
                    <Typography variant="body2">
                        {getTemplateLanguageLabel(customTemplate?.language) ||
                            '---'}
                    </Typography>
                </Box>
                <Box alignItems="center" display="flex" gap={1} mt={1}>
                    <Typography fontWeight="bold" variant="body2">
                        {t('Template type')}:
                    </Typography>
                    <Typography variant="body2">
                        {getTemplateTypeLabel(customTemplate?.type) || '---'}
                    </Typography>
                </Box>
                <Box alignItems="center" display="flex" gap={1} mt={1}>
                    <Typography fontWeight="bold" variant="body2">
                        {t('Created at')}:
                    </Typography>
                    <Typography variant="body2">
                        {customTemplate?.created_at}
                    </Typography>
                </Box>
                <PageProperties />
                <WidgetMenu />
            </Drawer>
        </WrapperSideMenu>
    );
};

SettingsDrawer.propTypes = {
    customTemplate: PropTypes.object,
    isDarkMode: PropTypes.bool,
    setShowSettingsDrawer: PropTypes.func,
    showSettingsDrawer: PropTypes.bool,
};

export default SettingsDrawer;
